import type { PageBodyStepper } from "@Light/components/page/PageBody";
import { isActive } from "./screen";
import type { EnrollmentScreen, Requirements } from "./types";

/**
 * Provides a `PageBodyStepper` for the screen at `path`, with the count being
 * the position of the screen relative to the `anchorPath` screen. Returns undefined
 * if the `anchorPath` hasn't been reached yet.
 */
export function stepperFor(
  path: string,
  anchorPath: string,
  screens: EnrollmentScreen[],
  initialRequirements: Requirements,
  requirements: Requirements,
): PageBodyStepper | undefined {
  const expected = screens.filter((screen) =>
    isActive(
      screen,
      initialRequirements,
      initialRequirements,
      new Set(),
      // Use initial requirements for typical matchers, but use current
      // requirements for "when" matchers to handle dynamicly shown screens.
      requirements,
    ),
  );
  const anchor = expected.findIndex((screen) => screen.path === anchorPath);
  const current = expected.findIndex((screen) => screen.path === path);
  if (anchor < 0 || current <= anchor) return undefined;

  return { current: current - anchor, last: expected.length - 1 - anchor };
}
